import _ from 'underscore';
import { reportType, dateRangePreset } from '@bingads-webui-campaign/reports-v4-strings';

function mapKeyValue(object, fn) {
  return _.chain(object)
    .pairs()
    .map(fn)
    .object()
    .value();
}


const frequencyType = {
  None: _TL_('None'),
  Daily: _TL_('Daily'),
  Weekly: _TL_('Weekly'),
  Monthly: _TL_('Monthly'),
  Other: _TL_('Other'),
};

export default ({ i18n }) => ({
  name: 'ReportV4MyReport',
  type: 'object',
  properties: {
    Name: {
      type: 'string',
      title: i18n.getString(_TL_('Report Name')),
      filterable: true,
      customColumn: true,
    },
    ReportType: {
      type: 'string',
      title: i18n.getString(_TL_('Report base')),
      chooseType: 'checkbox',
      filterable: true,
      customColumn: true,
      enum: Object.keys(reportType),
      localized: mapKeyValue(reportType, ([key, value]) => [
        `Enum.ReportType'${key}'`,
        i18n.getString(value),
      ]),
    },
    Frequency: {
      type: 'string',
      title: i18n.getString(_TL_('Schedule frequency')),
      chooseType: 'checkbox',
      filterable: true,
      customColumn: true,
      enum: Object.keys(frequencyType),
      localized: mapKeyValue(frequencyType, ([key, value]) => [
        `Enum.Frequency'${key}'`,
        i18n.getString(value),
      ]),
    },
    DateRangePreset: {
      type: 'string',
      title: i18n.getString(_TL_('Date range')),
      chooseType: 'checkbox',
      filterable: true,
      customColumn: true,
      enum: Object.keys(dateRangePreset),
      localized: mapKeyValue(dateRangePreset, ([key, value]) => [
        `Enum.DateRangePreset'${key}'`,
        i18n.getString(value),
      ]),
    },
    // remove filters of these tow columns for there exists bugs when using `equal` to filter
    // LastAccessedAt: {
    //   type: 'datetime',
    //   title: i18n.getString(_TL_('Last accessed')),
    //   filterable: true,
    //   customColumn: true,
    // },
    // CreatedAt: {
    //   type: 'datetime',
    //   title: i18n.getString(_TL_('Created on')),
    //   filterable: true,
    //   customColumn: true,
    // },
  },
});
